import { z } from 'zod';
import * as FlatModels from '../../internal';

export const ElementModelSchema = z.object({
  id: z.string(),
});

export type ElementModel = z.infer<typeof ElementModelSchema>;

export const SpriteModelSchema = ElementModelSchema.extend({
  offset: FlatModels.PointSharedModels.PointSchema.required(),
  scale: z.number(),
});

export type SpriteModel = z.infer<typeof SpriteModelSchema>;

export const VirtualPointerModelSchema = SpriteModelSchema;

export type VirtualPointerModel = z.infer<typeof VirtualPointerModelSchema>;

export const MarkerModelSchema = ElementModelSchema.extend({
  annotation: z.union([FlatModels.AnnotationEntityModels.MarkerSchema, FlatModels.AnnotationEntityModels.TextSchema]),
  label: FlatModels.AnnotationLabelEntityModels.AnnotationLabelSchema.optional(),
  source: FlatModels.AnnotationSourceEntityModels.AnnotationSourceSchema.optional(),
  targets: z.array(FlatModels.AnnotationTargetEntityModels.AnnotationTargetSchema),
});

export type MarkerModel = z.infer<typeof MarkerModelSchema>;

export const FreeformModelSchema = ElementModelSchema.extend({
  annotation: FlatModels.AnnotationEntityModels.FreeFormSchema,
  label: FlatModels.AnnotationLabelEntityModels.AnnotationLabelSchema.optional(),
  source: FlatModels.AnnotationSourceEntityModels.AnnotationSourceSchema.optional(),
  target: FlatModels.AnnotationTargetEntityModels.AnnotationTargetSchema.optional(),
  freeFormStyle: FlatModels.FreeFormStyleEntityModels.FreeFormStyleSchema.optional(),
});

export type FreeformModel = z.infer<typeof FreeformModelSchema>;

export const KeymapColumnModelSchema = ElementModelSchema.extend({
  keymap: z.string().uuid().optional(),
  labels: z.array(FlatModels.KeymapLabelEntityModels.KeymapLabelSchema),
  order: z.number().optional(),
});

export type KeymapColumnModel = z.infer<typeof KeymapColumnModelSchema>;

export const KeymapModelSchema = ElementModelSchema.extend({
  annotation: FlatModels.AnnotationEntityModels.KeymapSchema,
  label: FlatModels.AnnotationLabelEntityModels.AnnotationLabelSchema.optional(),
  source: FlatModels.AnnotationSourceEntityModels.AnnotationSourceSchema.optional(),
  // targets: z.array(FlatModels.AnnotationTargetEntityModels.AnnotationTargetSchema),
  keymapStyle: FlatModels.KeymapStyleEntityModels.KeymapStyleSchema,
  columns: z.array(KeymapColumnModelSchema),
});

export type KeymapModel = z.infer<typeof KeymapModelSchema>;

export const LabelModelSchema = ElementModelSchema.extend({
  text: z.string(),
});

export type LabelModel = z.infer<typeof LabelModelSchema>;

export const KeymapSelftestModelSchema = ElementModelSchema.extend({
  _model: KeymapModelSchema,
});

export type KeymapSelftestModel = z.infer<typeof KeymapSelftestModelSchema>;

export const TargetsElementModelsSchema = z.union([
  MarkerModelSchema,
  KeymapModelSchema,
]);

export type TargetsElementModels = z.infer<typeof TargetsElementModelsSchema>;

export const ElementModelsSchema = z.union([
  TargetsElementModelsSchema,
  FreeformModelSchema,
]);

export type ElementModels = z.infer<typeof ElementModelsSchema>;
